import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiAssignmentMetaDataResponseModel } from '@/types'

export const getKpiAssignmentMetaData = async (
  branchName: string
): Promise<KpiAssignmentMetaDataResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/kpi/assignment-metadata`, {
      params: {
        branch_name: branchName,
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
